export default __webpack_public_path__ + "static/media/BookDoc EB - Claim and Consent Form.ecdf4d8c.pdf";